import { MainArea, Page, Error, Button, Box, TopArea } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

type Props = {
  description?: string;
};

export function NotAuthorisedPage(props: Props) {
  const { t } = useTranslation('error');
  const history = useHistory();
  return (
    <MainArea>
      <TopArea>
        <AppTopBar />
      </TopArea>
      <Page padding={50}>
        <Box stackItems={true}>
          <Error
            heading={t('notAuthorised.heading')}
            description={props.description || t('notAuthorised.description')}
          />
          <Box horizontalPositioning="center">
            <Button
              variation="secondary"
              onClick={() => {
                history.push('/');
              }}
            >
              {t('notAuthorised.gotoDashboardButton.label')}
            </Button>
          </Box>
        </Box>
      </Page>
    </MainArea>
  );
}
